module.exports = new __parcel__URL__("aic_lab_level_1.bf217aae.png").toString();